export default "__VITE_PUBLIC_ASSET__27a4a180__"